import React from "react";
import { useAtom } from "jotai";
import { Navigate } from "react-router-dom";

import { tokenAtom } from "../atoms/accountAtom";

const PrivateRoute = ({ children }) => {
  const [token] = useAtom(tokenAtom);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
